var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "matrix(-1 0 0 1 56.5 0)",
    fill: "url(#paint0_linear_421_269)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7735 27.5C41.7735 34.8307 35.8307 40.7735 28.5 40.7735C21.1693 40.7735 15.2265 34.8307 15.2265 27.5C15.2265 20.1693 21.1693 14.2265 28.5 14.2265C35.8307 14.2265 41.7735 20.1693 41.7735 27.5ZM44 27.5C44 36.0604 37.0604 43 28.5 43C19.9396 43 13 36.0604 13 27.5C13 18.9396 19.9396 12 28.5 12C37.0604 12 44 18.9396 44 27.5ZM39.8894 27.5004C39.8894 33.7907 34.7901 38.8899 28.4999 38.8899C22.2097 38.8899 17.1104 33.7907 17.1104 27.5004C17.1104 21.2102 22.2097 16.1109 28.4999 16.1109C34.7901 16.1109 39.8894 21.2102 39.8894 27.5004ZM26.3785 24.8406H23.9448V31.0299H22.5915V24.8406H20.1683V23.6867H26.3785V24.8406ZM34.3 31.0299L34.2895 26.1624L31.8767 30.1907H31.2683L28.8555 26.2253V31.0299H27.5652V23.6867H28.6876L31.5935 28.5437L34.4678 23.6867H35.5798L35.6008 31.0299H34.3Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_269",
    x1: 23.0588,
    y1: 58.1961,
    x2: 43.9216,
    y2: 3.00613e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5162FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A670FF",
    stopOpacity: 0.46
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7c0c38a63930d16ef74f8c3cf21537f5.svg";
export { ForwardRef as ReactComponent };